import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useLessonRoomStore } from './store'
import { useTracksLiveKit } from './tracks-live-kit.hook'
import { useLessonRoomBooking } from './lesson-room/lesson-room-booking.hook'

// LiveKit "presenting" = a remote or local screen share, or an active nearpod. Single source so
// the controls-hide layout and RoomLiveKit's own stage never disagree.
export const useIsPresentingLiveKit = (): ComputedRef<boolean> => {
  const { remoteScreenTrack, isLocalScreenSharing } = useTracksLiveKit()
  const lessonRoomStore = useLessonRoomStore()
  const { nearpodCode } = useLessonRoomBooking(() => lessonRoomStore.getBooking)

  return computed<boolean>(() =>
    !!remoteScreenTrack.value || isLocalScreenSharing.value || !!nearpodCode.value,
  )
}
